export enum TaskGroup {
  ConceptReview = 'Concept Review',
  OutlineReview = 'Outline Review',
  MandatoryReview = 'Mandatory Review',
  ManagementSignoff = 'Management Signoff',
  AuthorReview = 'Author Review',
  PeerReview = 'Peer Review'
}
